import React, { useRef, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import SidebarNavigation from './SidebarNavigation';
import './styles.css';
import AuthenticatedRoutes from './routes/AuthenticatedRoutes';
import UnauthenticatedRoutes from './routes/UnauthenticatedRoutes';

/**
 * Hauptkomponente der Anwendung
 * Steuert die Authentifizierung und das grundlegende Layout
 */
const App = () => {
  // Referenz zum Hauptinhaltsbereich für Styling/Scrolling
  const contentRef = useRef(null);
  
  // Authentifizierungsstatus basierend auf dem Token
  const token = localStorage.getItem('accessToken');
  const [loggedIn, setLoggedIn] = useState(Boolean(token));

  return (
    <Router>
      <div className="h-screen bg-gray-100">
        {loggedIn ? (
          // Layout für authentifizierte Benutzer
          <div className="h-screen flex">
            {/* Seitenleiste */}
            <div className="w-1/6">
              <SidebarNavigation setLoggedIn={setLoggedIn} />
            </div>
            
            {/* Hauptinhalt */}
            <div ref={contentRef} className="w-5/6 overflow-scroll bg-gray-100">
              <AuthenticatedRoutes setLoggedIn={setLoggedIn} />
            </div>
          </div>
        ) : (
          // Routen für nicht authentifizierte Benutzer
          <UnauthenticatedRoutes setLoggedIn={setLoggedIn} />
        )}
      </div>
    </Router>
  );
};

export default App;
